<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="500px">
    <v-card>
      <v-card-title class="text-h5">{{ title }}</v-card-title>
      <v-card-text>
        <div v-if="message">{{ message }}</div>
        <slot />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="cancelColor" text @click="$emit('cancel'); $emit('input', false)">
          {{ cancelText || 'Cancelar' }}
        </v-btn>
        <v-btn :color="confirmColor" text @click="$emit('confirm'); $emit('input', false)">
          {{ confirmText || 'Aceptar' }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'DialogConfirm',
  props: {
    value: { type: Boolean, required: true },
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    confirmText: { type: String, default: 'Aceptar' },
    cancelText: { type: String, default: 'Cancelar' },
    confirmColor: { type: String, default: 'blue darken-1' },
    cancelColor: { type: String, default: 'red darken-1' }
  }
};
</script> 